var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 2.333a1.896 1.896 0 11-3.792 0 1.896 1.896 0 013.792 0z",
    fill: "#2355FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.074 4.667a2.336 2.336 0 01-2.333-2.334A2.336 2.336 0 0111.074 0a2.336 2.336 0 012.334 2.333 2.336 2.336 0 01-2.334 2.334zm0-3.792a1.46 1.46 0 00-1.458 1.458 1.46 1.46 0 001.458 1.459 1.46 1.46 0 001.459-1.459A1.46 1.46 0 0011.074.875zm1.896 10.792a1.896 1.896 0 11-3.792 0 1.896 1.896 0 013.792 0z",
    fill: "#2355FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.074 14a2.336 2.336 0 01-2.333-2.333 2.336 2.336 0 012.333-2.334 2.336 2.336 0 012.334 2.334A2.336 2.336 0 0111.074 14zm0-3.792a1.46 1.46 0 00-1.458 1.459 1.46 1.46 0 001.458 1.458 1.46 1.46 0 001.459-1.458 1.46 1.46 0 00-1.459-1.459zM4.803 7a1.896 1.896 0 11-3.791 0 1.896 1.896 0 013.791 0z",
    fill: "#2355FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.908 9.333A2.336 2.336 0 01.574 7a2.336 2.336 0 012.334-2.333A2.336 2.336 0 015.24 7a2.336 2.336 0 01-2.333 2.333zm0-3.791A1.46 1.46 0 001.449 7a1.46 1.46 0 001.459 1.458A1.46 1.46 0 004.366 7a1.46 1.46 0 00-1.458-1.458z",
    fill: "#2355FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.285 6.72a.582.582 0 01-.29-1.09l5.413-3.086a.582.582 0 11.578 1.014L4.573 6.643a.58.58 0 01-.288.077zm5.412 4.813a.579.579 0 01-.288-.077L3.996 8.37a.584.584 0 01.577-1.014l5.413 3.086a.584.584 0 01-.29 1.09z",
    fill: "#2355FC"
  })));
}

export default SvgShareBlue;